<template lang="pug">
  transition(name="fade", @after-enter="lockScroll(true)", @before-leave="lockScroll(false)")
    overlay.fixed.flex.items-center.justify-center(v-show="canAnim && viewerAt !== null", v-on="$listeners")
      carousel.h-screen.w-full(ref="carousel", :images="images", :noFullscreen="true", :noBgCover="true", :isViewer="true", :initialIndex="viewerAt")
</template>

<script>
import { mapMutations } from 'vuex'
import Overlay from '@/components/Overlay'
import Container from '@/components/Container'
const Carousel = () => import('./Carousel.vue')
export default {
  name: 'Viewer',
  props: ['images', 'viewerAt'],
  data () {
    return {
      canAnim: false
    }
  },
  methods: {
    ...mapMutations(['lockScroll'])
  },
  // watch: {
  //   viewerAt (ii) {
  //     if (!isNaN(ii)) this.$nextTick(() => this.$refs.carousel.jumpTo(ii, true))
  //   }
  // },
  mounted () {
    this.canAnim = true
  },
  destroyed () {
    this.lockScroll(false)
  },
  components: {
    Overlay,
    Container,
    Carousel
  }
}
</script>

<style>
</style>
